import { render, staticRenderFns } from "./DatasetUI.vue?vue&type=template&id=34d1d74a&"
import script from "./DatasetUI.vue?vue&type=script&lang=js&"
export * from "./DatasetUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports